<template>
  <div class="filter-bar">
    <div class="station-search-control">
      <v-autocomplete :model-value="stationId" :items="stationList" item-title="name" item-value="id"
        :custom-filter="stationSearchFilter" placeholder="搜索电站名称或ID" prepend-inner-icon="mdi-magnify"
        variant="outlined" density="compact" rounded="xl" hide-details clearable no-data-text="未找到匹配电站"
        class="station-search" @update:model-value="$emit('update:stationId', $event)">
        <template #item="{ props: itemProps, item }">
          <v-list-item v-bind="itemProps" :title="item.raw.name" :subtitle="`ID：${item.raw.id}`" />
        </template>
      </v-autocomplete>
    </div>
    <div class="seg-tabs">
      <div v-for="item in periods" :key="item.value" class="seg-tab" :class="{ active: period === item.value }"
        @click="$emit('update:period', item.value)">{{ item.label }}</div>
    </div>
    <v-btn color="primary" class="query-btn text-none" height="38" density="compact" rounded="xl"
      prepend-icon="mdi-magnify" @click="$emit('query')">查询</v-btn>
    <div style="flex:1" />
  </div>
</template>

<script setup>
defineProps({
  stationList: { type: Array, default: () => [] },
  stationId: { type: [String, Number], default: null },
  period: { type: String, default: '7' },
})

defineEmits(['update:stationId', 'update:period', 'query'])

const periods = [
  { label: '近7天', value: '7' },
  { label: '近30天', value: '30' },
  { label: '近90天', value: '90' },
]

function stationSearchFilter(value, query, item) {
  if (!query) return 0
  const station = item?.raw || {}
  const searchable = `${station.name || value || ''} ${station.id || ''}`.toLocaleLowerCase()
  return searchable.indexOf(String(query).toLocaleLowerCase())
}
</script>

<style scoped lang="scss">
.filter-bar {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 16px;
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(6px);
  padding: 14px 20px;
}

.station-search-control {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 0 auto;
}

.station-search {
  width: 292px;

  :deep(.v-field) {
    min-height: 38px;
    color: var(--text-primary);
    background: #fff;
    box-shadow: inset 0 0 0 1px #bdc9dd;
  }

  :deep(.v-field--focused) {
    box-shadow: inset 0 0 0 1.5px var(--primary), 0 0 0 3px var(--primary-faint);
  }

  :deep(.v-field__outline) {
    display: none;
  }

  :deep(.v-field__input) {
    min-height: 38px;
    padding-top: 7px;
    padding-bottom: 7px;
    font-size: 13px;
  }

  :deep(.v-field__prepend-inner) {
    color: var(--text-muted);
  }
}

.query-btn {
  min-width: 82px;
  box-shadow: none;
}

.seg-tabs {
  display: inline-flex;
  background: var(--surface-muted);
  border-radius: 10px;
  padding: 3px;
  gap: 2px;
  border: 1px solid color-mix(in srgb, var(--primary) 8%, var(--border));
}

.seg-tab {
  padding: 7px 16px;
  font-size: 13px;
  color: var(--text-secondary);
  border-radius: 8px;
  cursor: pointer;
  transition: color 0.2s, background 0.2s, box-shadow 0.2s;
  user-select: none;

  &:hover {
    color: var(--text-primary);
  }

  &.active {
    background: #fff;
    color: var(--primary);
    font-weight: 600;
    box-shadow: 0 2px 8px rgba(43, 87, 238, 0.1);
  }
}

@media (max-width: 900px) {
  .filter-bar {
    flex-wrap: wrap;
    padding-right: 84px;
  }

  .station-search-control {
    width: 100%;
  }

  .station-search {
    flex: 1;
    width: auto;
  }
}
</style>
